

import React, { memo } from 'react';
import PlayerCommonView from './PlayerCommonView';
import PlayerAudioView from './PlayerAudioView';
import { getTypeFromAsset } from '../../../common/utils';
import { AUDIO } from '../../../common/constants/fileTypes';










const PlayerVideo = ({ asset, ...otherProps }) => {
  const { metaData, filename } = asset;

  const type = getTypeFromAsset({ metaData, filename });

  if (type === AUDIO) {
    return <PlayerAudioView {...otherProps} />;
  }

  return <PlayerCommonView {...otherProps} />;
};

export default memo(PlayerVideo);